module.exports = __webpack_public_path__ + "img/w13.4fb95542.svg";